import "./product-customization-modal.scss";
import { html, nothing, PropertyValues } from "lit";
import ComponentModal from "./component-modal";
import "./product-selector";
import { property, state } from "lit/decorators.js";
import { CustomizationDto, ProductDto } from "../model/dtos";
import "./stepper";
import { CustomizationType } from "../model/models";

type CustomizationObj = {
  customizationId: number;
  productsId: number[];
};

class ProductCustomizationModal extends ComponentModal {
  static get tagName() {
    return "product-customization-modal";
  }

  @property()
  customizations: CustomizationDto[];
  @state()
  currentStep: number;
  @state()
  currentCustomizations: CustomizationObj[];

  constructor(resolve, reject, customizations: CustomizationDto[]) {
    super(resolve, reject);
    this.modalTitle = "Personalizza";
    this.customizations = customizations;
    this.currentStep = 0;
    this.currentCustomizations = [];
    this.onProductsSelection = this.onProductsSelection.bind(this);
    this.OnResize = this.OnResize.bind(this);
    this.fullScreen = this.CheckFullScreen();
  }

  get isMulti() {
    return (
      this.customizations[this.currentStep].type === CustomizationType.OTHER
    );
  }

  get isLastStep() {
    return this.customizations.length - 1 === this.currentStep;
  }

  get isCustomizationSelectedInCurrentStep() {
    return this.currentCustomizations.some(
      (cc) => cc.customizationId === this.customizations[this.currentStep].id
    );
  }

  onProductsSelection(ev: CustomEvent) {
    const product: ProductDto = ev.detail;
    const newCurrentCustomizations = [...this.currentCustomizations];
    const customizationIndex = newCurrentCustomizations.findIndex(
      (c) => c.customizationId === this.customizations[this.currentStep]?.id
    );
    const customization = newCurrentCustomizations[customizationIndex];
    if (!customization) {
      newCurrentCustomizations.push({
        customizationId: this.customizations[this.currentStep].id,
        productsId: [product.id],
      });
    } else {
      const i = customization.productsId.indexOf(product.id);
      if (i !== -1) {
        customization.productsId.splice(i, 1);
        if (customization.productsId.length === 0) {
          newCurrentCustomizations.splice(customizationIndex, 1);
        }
      } else {
        if (this.isMulti) customization.productsId.push(product.id);
        else customization.productsId = [product.id];
      }
    }
    this.currentCustomizations = [...newCurrentCustomizations];
  }

  OnSubmit() {
    this.Hide();
  }

  __OnSubmit() {
    if (this.currentStep < this.customizations.length - 1) {
      this.currentStep++;
      return;
    }
    this.data = this.currentCustomizations.map((cc) => {
      const customization = this.customizations.find(
        (c) => c.id === cc.customizationId
      );
      return {
        customizationId: customization.id,
        customizations: cc.productsId.map((pid) =>
          customization.choices.find((c) => c.id === pid)
        ),
      };
    });
    this._OnSubmit();
  }

  get modalFooter() {
    return html`
      ${this.currentStep > 0
        ? html`
            <button
              @click=${() => {
                if (this.currentStep > 0) this.currentStep--;
              }}
              type="button"
              class="btn btn-secondary btn-lg"
              .disabled=${this.currentStep === 0}
            >
              Indietro
            </button>
          `
        : nothing}
      <button
        @click=${this.__OnSubmit}
        type="button"
        class="btn btn-primary btn-lg btn-next"
        .disabled=${!this.isCustomizationSelectedInCurrentStep}
      >
        ${this.isLastStep ? "Fine" : "Avanti"}
      </button>
    `;
  }

  GetSelectedProducts(customization: CustomizationDto) {
    const _customization: CustomizationObj = this.currentCustomizations?.find(
      (c) => c.customizationId === customization.id
    );
    if (_customization) {
      return [..._customization.productsId];
    }
    return [];
  }

  get modalBody() {
    return html`
      <ncx-stepper
        .steps=${this.customizations.map(
          (customization) => html`
            <h6>${customization.name}</h6>
            <ncx-product-selector
              .multi=${this.isMulti}
              @products-selection=${this.onProductsSelection}
              .products=${customization.choices}
              .selectedProducts=${this.GetSelectedProducts(customization)}
            ></ncx-product-selector>
          `
        )}
        .currentStep=${this.currentStep}
      ></ncx-stepper>
      <div class="customize-product__notes">
        <!--label for="notes">Aggiungi note</label>
        <textarea id="notes" class="form-control"></textarea-->
      </div>
    `;
  }

  CheckFullScreen() {
    return screen.width < 500;
  }

  OnResize(e) {
    this.fullScreen = this.CheckFullScreen();
    this.requestUpdate();
  }

  connectedCallback(): void {
    super.connectedCallback();
    window.addEventListener("resize", this.OnResize);
  }
}
ProductCustomizationModal.Register();
export default ProductCustomizationModal;
